import {Component, TemplateRef, Input} from '@angular/core';
import { MenuService } from '../../../services/menu-service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})

export class NavbarComponent {
  @Input() navLeftTemplate?: TemplateRef<any>;
  @Input() navRightTemplate?: TemplateRef<any>;

  constructor() {}

}

